import "whatwg-fetch"
import MESSAGES from "AtomicConstants/MESSAGES"

const fetchAPI = ({
  url,
  method = "GET",
  body = null
}) => {
  const verificationTokenHeaderName = 'X-XSRF-TOKEN'
  const tokenElements = document.getElementsByName(verificationTokenHeaderName)
  const options = {
    method: method,
    credentials: "include",
    headers: {
      "content-type": "application/json"
    }
  }

  if (tokenElements.length === 1) {
    options.headers[verificationTokenHeaderName] = tokenElements[0].value
  }

  if (body) options.body = JSON.stringify(body)

  return new Promise(async (resolve, reject) => {
    return await fetch(url,options)
    .then(async (response) => {
      if (response.status === 200){
        resolve(response)
      }
      reject({
        status: response.status,
        message: response.status === 429 ? MESSAGES.SERVICE_MAX_TRIES : MESSAGES.UNEXPECTED_ERROR
      })
    })
  });
}

export default fetchAPI



// WEBPACK FOOTER //
// ./src/AtomicUtils/fetchAPI.js